import React from "react";
import "./About.css";

const About = () => {
  return (
    <>
      {/* Hero */}
      <section className="about-hero">
        <div className="overlay">
          <h1>About Piller</h1>
          <p>Trusted Real Estate Solutions For Your Dream Property</p>
        </div>
      </section>

      {/* About Intro */}
      <section className="about-intro">
        <div className="intro-left">
          <img src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c" />
        </div>
        <div className="intro-right">
          <span>ABOUT COMPANY</span>
          <h2>We Help Clients Buy, Sell & Invest in Properties</h2>
          <p>
            Piller is a professional real estate platform offering premium
            residential and commercial properties. We make property buying
            simple, transparent and secure for every client.
          </p>

          <div className="intro-grid">
            <div>✔ Verified Listings</div>
            <div>✔ Legal Assistance</div>
            <div>✔ Trusted Agents</div>
            <div>✔ Best Price Deals</div>
          </div>

          <button>Explore Properties</button>
        </div>
      </section>

      {/* Property Showcase */}
      <section className="about-properties">
        <h2>Our Featured Properties</h2>

        <div className="property-grid">
          <img src="https://images.unsplash.com/photo-1568605114967-8130f3a36994" />
          <img src="https://images.unsplash.com/photo-1572120360610-d971b9d7767c" />
          <img src="https://images.unsplash.com/photo-1580587771525-78b9dba3b914" />
          <img src="https://images.unsplash.com/photo-1598928506311-c55ded91a20c" />
        </div>
      </section>

      {/* Stats */}
      <section className="about-stats">
        <div><h3>1200+</h3><p>Properties</p></div>
        <div><h3>850+</h3><p>Happy Clients</p></div>
        <div><h3>15+</h3><p>Years Experience</p></div>
        <div><h3>50+</h3><p>Agents</p></div>
      </section>

      {/* Why Choose */}
      
<section className="why-choose">
  <h2>Why Choose Piller</h2>

  <div className="choose-grid">

    <div className="choose-card">
      <img src="https://images.unsplash.com/photo-1560518883-ce09059eeffa" />
      <h4>Premium Properties</h4>
      <p>We provide verified luxury residential and commercial properties.</p>
    </div>

    <div className="choose-card">
      <img src="https://images.unsplash.com/photo-1582407947304-fd86f028f716" />
      <h4>Trusted Agents</h4>
      <p>Professional agents to guide you from start to end.</p>
    </div>

    <div className="choose-card">
      <img src="https://images.unsplash.com/photo-1600585152220-90363fe7e115" />
      <h4>Best Price Deals</h4>
      <p>We ensure best market price for both buyers and sellers.</p>
    </div>

    <div className="choose-card">
      <img src="https://images.unsplash.com/photo-1560185127-6ed189bf02f4" />
      <h4>Legal Verified</h4>
      <p>All properties are legally verified and safe to invest.</p>
    </div>

    <div className="choose-card">
      <img src="https://images.unsplash.com/photo-1570129477492-45c003edd2be" />
      <h4>Wide Locations</h4>
      <p>Find properties across multiple cities in India.</p>
    </div>

    <div className="choose-card">
      <img src="https://images.unsplash.com/photo-1600585154084-4e5fe7c39198" />
      <h4>Fast Process</h4>
      <p>Quick property closing with full transparency.</p>
    </div>

  </div>
</section>


      
    </>
  );
};

export default About;
